import { CDNUrl } from '../constants/cdn.constants';

export const imgUrl = (url: string): string => {
    if (process.env.NODE_ENV === 'production') return CDNUrl.IMAGE_CDN + url;
    return '/wb' + url;
};
